export default "__VITE_ASSET__C060N9M4__"